import cn from 'classnames';
import { FC } from 'react';
import { CmsCta } from 'src/types/cms/cmsFieldTypes';
import { CmsActionGrid } from 'src/types/cms/cmsWidgetTypes';
import { WIDGET_STYLES_FOR_3_1 } from 'src/utils/constants';
import HomeWidget from './HomeWidget';

type Props = {
  widget?: CmsActionGrid | null;
  redirect: (action?: CmsCta) => void;
};
const Template_3_1: FC<Props> = ({ widget, redirect }) => {
  return (
    <>
      {widget?.actionGridItems.map((item, index) => (
        <HomeWidget
          key={index}
          widgetData={item}
          btnStyles={WIDGET_STYLES_FOR_3_1[index]?.btnStyles}
          redirect={redirect}
          cls={cn(WIDGET_STYLES_FOR_3_1[index]?.cls, `${WIDGET_STYLES_FOR_3_1[index]?.cls}_${index + 1}`)}
        />
      ))}
    </>
  );
};
export default Template_3_1;
